"use strict";

exports.__esModule = true;
exports.DataItemChartV2Fields = DataItemChartV2Fields;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _Device = require("../../Device");
var _VisualMapSelector = require("../../Echarts/FieldSelectors/VisualMapSelector");
var _ChartTitleSelector = require("../../Echarts/FieldSelectors/ChartTitleSelector");
var _ToolBoxSelector = require("../../Echarts/FieldSelectors/ToolBoxSelector");
var _StatisticsCalculationsSelector = require("../../Echarts/FieldSelectors/StatisticsCalculationsSelector");
var _ChartItemsSelector = require("../../Echarts/FieldSelectors/ChartItems/ChartItemsSelector");
var _ChartControlsSelector = require("../../Echarts/FieldSelectors/ChartControlsSelector");
var _DataItemSelector = require("../../Echarts/FieldSelectors/DataItemSelector");
var _constants = require("../../Echarts/constants");
var _constants2 = require("../DataItemChart/constants");
var _MultiFieldSelector = require("../../Recharts/Fields/MultiFieldSelector/MultiFieldSelector");
var _widget = require("./widget");
var _helper = require("../MeasureChart/helper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Fields for DataItemChartV2Element.
 */
function DataItemChartV2Fields(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var _element$props = element.props,
    dataItemSource = _element$props.dataItemSource,
    title = _element$props.title,
    toolbox = _element$props.toolbox,
    statistics = _element$props.statistics,
    visualMap = _element$props.visualMap,
    chartItems = _element$props.chartItems,
    controls = _element$props.controls,
    _element$props$dataIt = _element$props.dataItems,
    dataItems = _element$props$dataIt === void 0 ? [] : _element$props$dataIt,
    _element$props$realti = _element$props.realtimeItems,
    realtimeItems = _element$props$realti === void 0 ? [] : _element$props$realti,
    _element$props$histor = _element$props.historicalItems,
    historicalItems = _element$props$histor === void 0 ? [] : _element$props$histor;
  (0, _react.useEffect)(function () {
    if (!dataItemSource) {
      elementEditor.setProp(path, "dataItemSource", _widget.REALTIME_ITEMS);
    }
  }, [element, elementEditor, path]);
  var dataSourceItems = [{
    value: _widget.REALTIME_ITEMS,
    translateToken: "DataItemChartV2Fields.dataItemSourceRealtime.label",
    defaultTranslate: "Realtime Data Item"
  }, {
    value: _widget.HISTORICAL_ITEMS,
    translateToken: "DataItemChartV2Fields.dataItemSourceHistorical.label",
    defaultTranslate: "Historical Data Item"
  }, {
    value: _widget.MTC_ITEMS,
    translateToken: "DataItemChartV2Fields.dataItemSourceMtc.label",
    defaultTranslate: "MTC Data Item"
  }];
  var renderSelectorForRealtimeAndHistoricalItems = function renderSelectorForRealtimeAndHistoricalItems(selectedItems, prop) {
    return /*#__PURE__*/_react["default"].createElement(_MultiFieldSelector.MultiFieldSelector, {
      getKey: function getKey(input) {
        return String(input.dataItemIndex);
      },
      renderItemText: function renderItemText(input) {
        return input.dataItemLabel;
      },
      itemPredicate: function itemPredicate(query, _ref) {
        var dataItemLabel = _ref.dataItemLabel;
        return dataItemLabel.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      },
      selectedItems: selectedItems,
      onChange: function onChange(selectedValues) {
        return elementEditor.setProp(path, prop, selectedValues);
      },
      items: _constants2.dataItemIndexArray
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_Device.DeviceListContext.Consumer, null, function (devices) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_helper.Well, {
      "data-testid": "DataItemChartV2Fields.dataItems"
    }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("DataItemChartV2Fields.dataItems.label", "Data Item selection")), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DataItemChartV2Fields.dataItemSource.label", "Data Item Source")
    }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
      dataTestId: "DataItemChartV2Fields.dataItemSource.selector",
      items: dataSourceItems,
      selected: [dataItemSource || _widget.REALTIME_ITEMS],
      getKey: function getKey(e) {
        return e.value;
      },
      renderItemText: function renderItemText(e) {
        return translate(e.translateToken, e.defaultTranslate);
      },
      onSelect: function onSelect(_ref2) {
        var selected = _ref2[0];
        elementEditor.setProps(path, {
          dataItemSource: selected.value,
          dataItems: []
        });
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DataItemSelector.dataItemOptions.label", "Data Item options")
    }, dataItemSource === _widget.REALTIME_ITEMS && /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "DataItemChartV2Fields.dataItems.realtime"
    }, renderSelectorForRealtimeAndHistoricalItems(realtimeItems, "realtimeItems")), dataItemSource === _widget.HISTORICAL_ITEMS && /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "DataItemChartV2Fields.dataItems.historical"
    }, renderSelectorForRealtimeAndHistoricalItems(historicalItems, "historicalItems")), dataItemSource === _widget.MTC_ITEMS && /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "DataItemChartV2Fields.dataItems.mtc"
    }, /*#__PURE__*/_react["default"].createElement(_DataItemSelector.DataItemSelector, {
      path: path,
      elementEditor: elementEditor,
      dataItems: dataItems,
      devices: devices
    })))), /*#__PURE__*/_react["default"].createElement(_ChartItemsSelector.ChartItemsSelector, {
      path: path,
      elementEditor: elementEditor,
      chartItems: chartItems,
      blacklistItems: [_constants.CHART_PIE]
    }), /*#__PURE__*/_react["default"].createElement(_ChartTitleSelector.ChartTitleSelector, {
      path: path,
      elementEditor: elementEditor,
      title: title
    }), /*#__PURE__*/_react["default"].createElement(_ToolBoxSelector.ToolBoxSelector, {
      path: path,
      elementEditor: elementEditor,
      toolbox: toolbox
    }), /*#__PURE__*/_react["default"].createElement(_StatisticsCalculationsSelector.StatisticsCalculationsSelector, {
      path: path,
      elementEditor: elementEditor,
      statistics: statistics
    }), /*#__PURE__*/_react["default"].createElement(_VisualMapSelector.VisualMapSelector, {
      path: path,
      elementEditor: elementEditor,
      visualMap: visualMap
    }), /*#__PURE__*/_react["default"].createElement(_ChartControlsSelector.ChartControlsSelector, {
      path: path,
      elementEditor: elementEditor,
      controls: controls
    }));
  });
}